module.exports = __webpack_public_path__ + "static/media/redCrossIcon.e4794485.svg";